<template>
  <div class="cp-set-review-sites main">
    <div class="divider" />
    <div class="row">
      <p>
        <i class="fab fa-tripadvisor icon" />Review Sites
        <span class="is-pulled-right tag is-rounded" @click="commaSpaceReminder"
          >{{ siteCount }} Sites</span
        >
      </p>
      <div style="margin-top: 10px">
        <textarea
          ref="textarea"
          class="textarea"
          v-model="reviewSites"
          placeholder="facebook.com/yourbusiness, tripadvisor.com/yourbusiness"
          @focus="resizeTextarea"
          @keyup="resizeTextarea"
        />
      </div>
      <p class="hint">
        Enter a comma+space separated list of review sites:
        <br />
        <i>url_1, url_2, url_3</i>
      </p>
      <div class="save-wrapper">
        <p v-if="updatingReviewSites" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveReviewSites">
          Save
        </p>
      </div>
    </div>

    <div v-if="$store.getters.isSuperUser">
      <div class="divider" />
      <div class="row" style="background-color: #eef">
        <p>
          <i class="fa fa-quote-left icon" />Quotes
          <span class="is-pulled-right tag is-rounded" @click="brReminder"
            >{{ quoteCount }} Quotes</span
          >
        </p>
        <div style="margin-top: 10px">
          <textarea
            class="textarea"
            v-model="quotes"
            :placeholder="`Best chicken this side of the equator! <br> 
Just awesome food <br>
The friendliest staff and the nicest ambience! <br>`"
          />
        </div>
        <p class="hint">
          Enter a &#60;br&#62; separated list of quotes:
          <br />
          <i>quote_1 &#60;br&#62; quote_2 &#60;br&#62; quote_3</i>
        </p>
        <div class="save-wrapper">
          <p v-if="updatingQuotes" class="button">
            <i class="fa fa-spinner fa-spin" />
          </p>
          <p v-else class="button has-text-success" @click="saveQuotes">Save</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPSetReviewSites",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      quotes: null,
      reviewSites: null,
      updatingReviewSites: false,
      updatingQuotes: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    siteCount() {
      if (!this.reviewSites) return 0;
      return this.reviewSites.split(", ").length;
    },
    quoteCount() {
      if (!this.quotes) return 0;
      return this.quotes.split("<br>").length;
    },
  },
  mounted() {
    this.reviewSites = this.business.data.review_sites;
    this.quotes = this.business.data.quotes;
    this.$nextTick(() => this.resizeTextarea());
  },
  methods: {
    resizeTextarea() {
      var el = this.$refs.textarea;
      el.style.height = "";
      el.style.height = el.scrollHeight + 40 + "px";
    },
    brReminder() {
      var msg = `<div style='text-align:left'>
      Remember quotes must be<br>separated by a &#60;br&#62; tag<br><i>quote_1 &#60;br&#62; quote_2</i>
      </div>`;
      this.infoToast(msg, "top", 5000);
    },
    commaSpaceReminder() {
      var msg = `<div style='text-align:left'>
      Remember site URLs must be<br>separated by a comma and space:<br><i>url_1, url_2, url_3</i>
      </div>`;
      this.infoToast(msg, "top", 5000);
    },
    saveReviewSites() {
      if (!this.reviewSites || this.reviewSites.length < 5) {
        var msg = "Enter comma-separated list<br>of review site URLs";
        this.errorToast(msg);
        return;
      }
      this.updatingReviewSites = true;
      var obj = { review_sites: this.reviewSites };
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated review sites");
          this.business.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingReviewSites = false));
    },
    saveQuotes() {
      if (!this.quotes || this.quotes.length < 5) {
        var msg = "Enter a <br> separated list<br>of customer quotes";
        this.errorToast(msg);
        return;
      }
      this.updatingQuotes = true;
      var obj = { quotes: this.quotes };
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated quotes");
          this.business.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingQuotes = false));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.hint {
  margin-top: 6px;
  margin-left: 4px;
  color: grey;
  font-size: 0.9em;
}
</style>
